<template>
  <div class="page d-flex">
    <PaymentViewComponent />
  </div>
</template>

<script>
import MenuComponent from "@/components/user/layout/MenuComponent.vue";
import PaymentViewComponent from "@/components/user/viewComponent/payment/PaymentViewComponent.vue";

export default {
  name: "ListView",
  components: {
    MenuComponent: MenuComponent,
    PaymentViewComponent,
  },
};
</script>
